module.exports = __webpack_public_path__ + "0f285dc4c54c8f75845515bd633d63d7.woff";